var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"flag-col"}},[_c('div',{staticClass:"mt-2 img-flag--container"},[(_vm.imgSrc)?_c('img',{staticClass:"rounded",attrs:{"src":_vm.imgSrc,"border":"1"}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }